import React from 'react';
import {Form, Button} from 'semantic-ui-react';

/* eslint-disable max-params */
function renderAccessory(accessory, handleDeleteAccessory, idx, validateStatus) {
  return (
    <div key={idx} className="tcc-budget-container animated fadeInUp">
      <span className="tcc-budget-container__item">{accessory}</span>
      {!validateStatus && (
        <span className="tcc-budget-container__icon" onClick={() => handleDeleteAccessory(accessory)}>
          <img height="10" src={`${process.env.PUBLIC_URL}/icons/close-tcc.svg`} alt="delete icon"></img>
        </span>
      )}
    </div>
  );
}

const AccesoriesBudgetContainer = ({accessories, handleDeleteAccessory, validateStatus}) => {
  return (
    <div className="tcc-container-accesories-budgets">
      {accessories.map((accessory, idx) => renderAccessory(accessory, handleDeleteAccessory, idx, validateStatus))}
    </div>
  );
};

const Accesories = ({
  accessories,
  accessory,
  handleInput,
  handleAddAccessory,
  handleDeleteAccessory,
  validateStatus,
}) => {
  return (
    <div className="tcc-container-accesories">
      <Form.Group widths={4}>
        <Form.Input
          name="accessory"
          value={accessory}
          onChange={handleInput}
          fluid
          label={'Agregar accesorios (Opcional)'}
          placeholder={'Agregar accesorio'}
        />
        <div className="mt-2">
          <Button disabled={accessory.length <= 2 || validateStatus} onClick={handleAddAccessory} color="blue">
            +
          </Button>
        </div>
        <AccesoriesBudgetContainer
          accessories={accessories}
          handleDeleteAccessory={handleDeleteAccessory}
          validateStatus={validateStatus}
        />
      </Form.Group>
    </div>
  );
};

export default Accesories;
